import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-orm';
import { APUserModeConfig } from '../../global/components/user_mode_config/config/ap_user_mode_config';
import { APModel } from '../../global/models/ap_model';
import { FeedbackSuggestedPlanModel } from '../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { PlanFeedbackServant } from '../../suggestions/components/plan_feedback/servants/plan_feedback_servant';
import { APAlternatePlanListItem } from '../builders/ap_alternate_plan_list_item_builder';
import { IAPAlternatePlanListDatasource } from '../datasources/alternate_plan_list_datasource';

export interface IAPAlternatePlanListQueryListItem {
  id: number;
  name: string;
  credit_range: string;
  is_visible_to_student: boolean;
  is_selectable_by_student: boolean;
}

export interface IAPAlternatePlanListQueryResult {
  hasPlans: boolean;
  specializationName: string;
  planList: IAPAlternatePlanListQueryListItem[];
  shouldShowBasePlanWarning: boolean;
}

export class APAlternatePlanListQuery implements IQuery {
  private __result: IAPAlternatePlanListQueryResult;

  constructor(
    private ngAPAlternatePlanListDatasource: IAPAlternatePlanListDatasource,
    private ngAPModel: APModel,
    private ngAPUserModeConfig: APUserModeConfig,
    private ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel
  ) {
    ORMMediator.registerQuery(this, ngAPAlternatePlanListDatasource, ngFeedbackSuggestedPlanModel);
  }

  getPlanList() {
    const currentProgramId = this.ngAPModel.currentProgram().id;
    const planListWithoutCurrentPlan = _4.reject(this.ngAPAlternatePlanListDatasource.read(), { id: currentProgramId });
    return _4.map(planListWithoutCurrentPlan, (planListItem) => ({
      id: planListItem.id,
      name: planListItem.name,
      credit_range:
        planListItem.max_credits === planListItem.min_credits
          ? `${planListItem.max_credits}`
          : `${planListItem.min_credits} - ${planListItem.max_credits}`,
      is_visible_to_student: this.ngAPUserModeConfig.isAdvisor() && planListItem.is_visible_to_student,
      is_selectable_by_student: this.ngAPUserModeConfig.isAdvisor() && planListItem.is_selectable_by_student
    }));
  }

  getNumberOfBasePlans() {
    return _4.size(
      _4.filter(this.ngAPAlternatePlanListDatasource.read(), (alternatePlan) => alternatePlan.is_base_plan)
    );
  }

  run(): this {
    const currentProgramId = this.ngAPModel.currentProgram().id;
    const advisorInViewMode = PlanFeedbackServant.isPlanReadOnlyMode(this.ngFeedbackSuggestedPlanModel.read());
    const planList = this.getPlanList();
    const planListWithoutCurrentPlan = _4.reject(planList, { id: currentProgramId });
    const isAdvisorViewMode = this.ngAPUserModeConfig.isAdvisor() && advisorInViewMode;
    const showAlternatePlanLink =
      !_4.isEmpty(planListWithoutCurrentPlan) && (isAdvisorViewMode || this.ngAPUserModeConfig.isStudent());
    const specializationName = showAlternatePlanLink
      ? _4.get(this.ngAPAlternatePlanListDatasource.get(currentProgramId) as APAlternatePlanListItem, 'name', '')
      : '';
    const isWrongBasePlanAssigned = _4.gt(this.getNumberOfBasePlans(), 1);
    this.__result = {
      hasPlans: showAlternatePlanLink,
      planList,
      specializationName,
      shouldShowBasePlanWarning: isWrongBasePlanAssigned
    };
    return this;
  }

  get result(): IAPAlternatePlanListQueryResult {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPAlternatePlanListQuery', APAlternatePlanListQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/queries/ap_alternate_plan_list_query.ts